import releaseInfo from "@/../release-info.json"
import SmallLogo from "@/assets/images/small-logo.svg"
import { Navigation } from "@/layouts/navigation"
import { ReleaseInfo } from "@/layouts/release-info"
import { UserPopup } from "@/layouts/user-popup"
import { cn } from "@/lib/utils"

interface NavbarProps extends React.HTMLAttributes<HTMLElement> {
  subNavigation?: React.ReactNode
}

const Navbar = ({ subNavigation, className, children }: NavbarProps) => {
  console.log("Release info data", releaseInfo)
  return (
    <nav data-testid="left-navigation" className={cn("z-10 grid grid-cols-[auto_auto]", className)}>
      <div className="border-border flex min-h-0 w-22 flex-col border-r">
        <div className="flex h-16 w-full shrink-0 items-center justify-center" data-testid="left-navigation-logo">
          <img src={SmallLogo} height="32" width="32" alt="Sofia Logo" />
        </div>
        <div className="scrollbar-thumb-rounded-full scrollbar-w-1 hover:scrollbar-thumb-surface-pressed flex min-h-0 flex-1 scrollbar-thin scrollbar-thumb-transparent scrollbar-track-transparent scrollbar-gutter-both flex-col items-center overflow-y-auto pt-4">
          <Navigation />
          {children}
        </div>
        <div className="flex shrink-0 flex-col items-center pt-4 pb-2">
          <UserPopup />
          <ReleaseInfo />
        </div>
      </div>
      {subNavigation}
    </nav>
  )
}

export { Navbar }
